<template>
  <div id="pubStatisticChart" style="width: 100%; height: 300px"></div>
</template>

<script>
export default {
  name: 'pubStatisticChart',
  props: ['seriesData', 'num'],
  data() {
    return {
      myChart: null,
    };
  },
  watch: {
    seriesData: {
      handler() {
        this.getOption();
      },
    },
  },
  created() {
    this.$nextTick(() => {
      this.getOption();
    });
  },
  methods: {
    getOption() {
      this.myChart = this.$echarts.init(
        document.getElementById('pubStatisticChart'),
      );
      let that = this;
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            // params 是一个对象，包含多个属性，如：seriesName, name, value, etc.
            return params.name + ' : ' + params.value + '%';
          },
        },
        // legend: {    top: '5%',    left: 'center'  },
        //  部分代码
        graphic: [
          {
            //环形图中间添加文字
            type: 'text', //通过不同top值可以设置上下显示
            left: 'center',
            top: 'center',
            style: {
              text: `发表论文总数 \n${that.num}篇`,
              textAlign: 'center',
              fontSize: 14,
            },
          },
        ],

        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '60%'], // 设置环形图的内外半径
            center: ['50%', '50%'], // 设置圆心位置
            data: that.seriesData,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  // 使用\n进行换行，并使用HTML标签设置样式
                  return `${params.name}\n${params.value}%`;
                },
              },
            },
          },
        ],
      };
      this.myChart.setOption(option, true);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
  },
};
</script>

<style scoped lang="less"></style>
